__turbopack_context__.v({
  "buttonSecondary": "_2O_myG_buttonSecondary",
  "card": "_2O_myG_card",
  "container": "_2O_myG_container",
  "divider": "_2O_myG_divider",
  "dividerText": "_2O_myG_dividerText",
  "error": "_2O_myG_error",
  "footer": "_2O_myG_footer",
  "footerText": "_2O_myG_footerText",
  "formGroup": "_2O_myG_formGroup",
  "formGroupLast": "_2O_myG_formGroupLast",
  "loginOptions": "_2O_myG_loginOptions",
  "title": "_2O_myG_title",
});
